import { denormalisedResponseEntities } from '../../../../util/data';
import { types as sdkTypes, createImageVariantConfig } from '../../../../util/sdkLoader';
import { storableError } from '../../../../util/errors';

// ================ Action types ================ //

export const FETCH_LISTINGS_BY_CATEGORY_REQUEST = 'app/sectionSlider/FETCH_LISTINGS_BY_CATEGORY_REQUEST';
export const FETCH_LISTINGS_BY_CATEGORY_SUCCESS = 'app/sectionSlider/FETCH_LISTINGS_BY_CATEGORY_SUCCESS';
export const FETCH_LISTINGS_BY_CATEGORY_ERROR = 'app/sectionSlider/FETCH_LISTINGS_BY_CATEGORY_ERROR';

// ================ Reducer ================ //

const initialState = {
  listingsByCategory: {}, // { categoryId: [listings] }
  loading: {}, // { categoryId: true/false }
  error: {}, // { categoryId: error }
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case FETCH_LISTINGS_BY_CATEGORY_REQUEST:
      return {
        ...state,
        loading: { ...state.loading, [payload.categoryId]: true },
        error: { ...state.error, [payload.categoryId]: null },
      };

    case FETCH_LISTINGS_BY_CATEGORY_SUCCESS:
      return {
        ...state,
        listingsByCategory: { 
          ...state.listingsByCategory, 
          [payload.categoryId]: payload.listings 
        },
        loading: { ...state.loading, [payload.categoryId]: false },
        error: { ...state.error, [payload.categoryId]: null },
      };

    case FETCH_LISTINGS_BY_CATEGORY_ERROR:
      return {
        ...state,
        loading: { ...state.loading, [payload.categoryId]: false },
        error: { ...state.error, [payload.categoryId]: payload.error },
      };

    default:
      return state;
  }
}

// ================ Action creators ================ //

const fetchListingsByCategoryRequest = (categoryId) => ({
  type: FETCH_LISTINGS_BY_CATEGORY_REQUEST,
  payload: { categoryId },
});

const fetchListingsByCategorySuccess = (categoryId, listings) => ({
  type: FETCH_LISTINGS_BY_CATEGORY_SUCCESS,
  payload: { categoryId, listings },
});

const fetchListingsByCategoryError = (categoryId, error) => ({
  type: FETCH_LISTINGS_BY_CATEGORY_ERROR,
  payload: { categoryId, error },
  error: true,
});

// ================ Thunks ================ //

export const fetchListingsByCategory = (config, categoryId, limit = 100) => (dispatch, getState, sdk) => {
  dispatch(fetchListingsByCategoryRequest(categoryId));
  //console.log("👍", Math.floor(Math.random() * 1000000))
  /*
  const params = {
    pub_categoryLevel1: categoryId,
    states: 'published',
    perPage: limit,
    include: ['author', 'images'],
    'fields.image': ['variants.square-small', 'variants.square-small2x'],
  };
  */

  const {
      aspectWidth = 1,
      aspectHeight = 1,
      variantPrefix = 'listing-card',
  } = config.layout.listingImage;

  // const aspectWidth = 1;
  // const aspectHeight = 1;
  // const variantPrefix = 'listing-card';
  const aspectRatio = aspectHeight / aspectWidth;

  /*
  const params = {
    id: listingId,
    include: ['author', 'author.profileImage', 'images', 'currentStock'],
    'fields.image': [
      // Scaled variants for large images
      'variants.scaled-small',
      'variants.scaled-medium',
      'variants.scaled-large',
      'variants.scaled-xlarge',

      // Cropped variants for listing thumbnail images
      `variants.${variantPrefix}`,
      `variants.${variantPrefix}-2x`,
      `variants.${variantPrefix}-4x`,
      `variants.${variantPrefix}-6x`,

      // Social media
      'variants.facebook',
      'variants.twitter',

      // Avatars
      'variants.square-small',
      'variants.square-small2x',
    ],
    ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
    ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
    ...createImageVariantConfig(`${variantPrefix}-4x`, 1600, aspectRatio),
    ...createImageVariantConfig(`${variantPrefix}-6x`, 2400, aspectRatio),
  };
  */

  const params = {
    pub_categoryLevel1: categoryId,
    states: 'published',
    perPage: limit,
    randomSeed: Math.floor(Math.random() * 1000000), // ← Agregar esta línea
    include: ['author', 'images'], // incluir autor e imágenes
    pub_listingType: ['free-listing'],
    pub_isProduct: true,
    pub_isActive: true,
    'fields.listing': [
      'title',
      'geolocation',
      'price',
      'deleted',
      'state',
      'publicData.listingType',
      'publicData.transactionProcessAlias',
      'publicData.unitType',
      // Estos campos ayudan al renderizado de listings de 'purchase'
      'publicData.pickupEnabled',
      'publicData.shippingEnabled',
    ],
    'fields.user': ['profile.displayName', 'profile.abbreviatedName'],
    'fields.image': [
      `variants.${variantPrefix}`,
      `variants.${variantPrefix}-2x`,
      `variants.${variantPrefix}-4x`,
      `variants.${variantPrefix}-6x`,
    ],
    // Configuración de variantes de imagen
    ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
    ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
    ...createImageVariantConfig(`${variantPrefix}-4x`, 1600, aspectRatio),
    ...createImageVariantConfig(`${variantPrefix}-6x`, 2400, aspectRatio),
    'limit.images': 1, // límite de imágenes por listing
  };

  return sdk.listings
    .query(params)
    .then(response => {
      const listings = denormalisedResponseEntities(response);
      const shuffled = listings.sort(() => 0.5 - Math.random());
      const selectedListings = shuffled.slice(0, 4);
      //console.log("👀👀👀👀", selectedListings);
      dispatch(fetchListingsByCategorySuccess(categoryId, selectedListings));
      return listings;
    })
    .catch(e => {
      dispatch(fetchListingsByCategoryError(categoryId, storableError(e)));
      throw e;
    });
};